import {createAction, props} from '@ngrx/store';
import { GreenIdModel } from './state';

 export const RequestVerificationCodeAction = createAction('[GreenId] verification token get', props<{account: number}>());
 export const ResponseVerificationCodeAction = createAction('[GreenId] verification token set', props<{data: GreenIdModel}>());

 export const UpdateOverallStatusAction = createAction('[GreenId] overall status get', props<{status: string}>());


 export const RequestVerifiedAction = createAction('[GreenId] verified get', props<{account: number, verificationId: string}>());
 export const ResponseVerifiedAction = createAction('[GreenId] verified set', props<{data: any}>());

export const ScriptLoadedAction = createAction('[GreenId] script loaded');

export const RecordConsentAction = createAction('[GreenId] record consent', props<{account: number, verificationId: string}>());
export const ResponseConsentAction = createAction('[GreenId] record consent set');
export const ConsentFailedAction = createAction('[GreenId] record consent failed');
